module.exports = __webpack_public_path__ + "static/media/funnel_building_formula.df6a8341.jpg";